export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
  /*
    var itemSelector = '.element-item';     
    var $checkboxes = jQuery('.filters-select');
    var $container =  jQuery('.grid').isotope({ itemSelector: itemSelector });

    //Ascending order
    var responsiveIsotope = [ [480, 2] , [720, 4] ];
    var itemsPerPageDefault = 20;
    var itemsPerPage = defineItemsPerPage();
    var currentNumberPages = 1;
    var currentPage = 1;
    var currentFilter = '*';
    var filterAttribute = 'data-filter';
    var filterValue = '';
    var pageAttribute = 'data-page';
    var pagerClass = 'isotope-pager';

    function changeFilter(selector) { $container.isotope({ filter: selector }); }
    //grab all checked filters and goto page on fresh isotope output
    function goToPage(n) {
    currentPage = n;
    //var selector = itemSelector;
    //var exclusives = [];
      // for each box checked, add its value and push to array
      $checkboxes.on( 'change', function() {
       
          if (this.value) {
              
              filterValue = this.value;
              // add page number to the string of filters
              var wordPage = currentPage.toString();
              filterValue += ('.'+wordPage);

              changeFilter(filterValue);
          }
      });
      
    }

    // determine page breaks based on window width and preset values
    function defineItemsPerPage() {
    var pages = itemsPerPageDefault;

    for( var i = 0; i < responsiveIsotope.length; i++ ) {
      if( jQuery(window).width() <= responsiveIsotope[i][0] ) {
          pages = responsiveIsotope[i][1];
          break;
      }
    }
    return pages;
    }

    function setPagination() {

    
      //var itemsLength = $container.children(itemSelector).length;
      //var pages = Math.ceil(itemsLength / itemsPerPage);
      var item = 1;
      var page = 1;
      var selector = itemSelector;
      var exclusives = [];
          // for each box checked, add its value and push to array
          $checkboxes.each(function (i, elem) {
              if (elem.checked) {
                  selector += ( currentFilter != '*' ) ? '.'+elem.value : '';
                  exclusives.push(selector);
              }
          });
          // smash all values back together for 'and' filtering
          filterValue = exclusives.length ? exclusives.join('') : '.standards.legal-compliance.sectors.management-systems';

          alert(filterValue);
          // find each child element with current filter values
          $container.children(filterValue).each(function(){
              // increment page if a new one is needed
              if( item > itemsPerPage ) {
                  page++;
                  item = 1;
              }
              // add page number to element as a class
             var wordPage = page.toString();
              
              var classes = jQuery(this).attr('class').split(' ');
              var lastClass = classes[classes.length-1];
              // last class shorter than 4 will be a page number, if so, grab and replace
              if(lastClass.length < 4){
                  jQuery(this).removeClass();
                  classes.pop();
                  classes.push(wordPage);
                  classes = classes.join(' ');
                  jQuery(this).addClass(classes);
              } else {
                  // if there was no page number, add it
                jQuery(this).addClass(wordPage); 
              }
              item++;
          });
      currentNumberPages = page;
 

    // create page number navigation


      var $isotopePager = ( jQuery('.'+pagerClass).length == 0 ) ? jQuery('<div class="'+pagerClass+'"></div>') : jQuery('.'+pagerClass);

      $isotopePager.html('');
      if(currentNumberPages > 1){
        for( var i = 0; i < currentNumberPages; i++ ) {
            var $pager = jQuery('<a href="javascript:void(0);" class="pager" '+pageAttribute+'="'+(i+1)+'"></a>');
                $pager.html(i+1);

                $pager.click(function(){
                    var page = jQuery(this).eq(0).attr(pageAttribute);
                    goToPage(page);
                });
            $pager.appendTo($isotopePager);
        }
      }
      $container.after($isotopePager);
   
    }


    setPagination();
    goToPage(1);

    //event handlers
    $checkboxes.change(function(){
    var filter = jQuery(this).attr(filterAttribute);
    currentFilter = filter;
    setPagination();
    goToPage(1);
    });
*/
},
};


// WEBPACK FOOTER //
// ./scripts/routes/templateLearningResourcesPage.js